export default __webpack_public_path__ + "static/media/valleyPort3.da00bed0.png";